import title from 'title'
import i18n from '../i18n'

const frenchStopWords = [
  'de',
  'du',
  'des',
  'la',
  'le',
  'et',
  'au',
  'aux',
  'les',
  'en',
  'dans',
]

export const formatTitle = (text: string): string => {
  if (!text) return ''

  const lang = i18n.language

  if (lang === 'fr') {
    const words = text.toLowerCase().split(' ')
    return words
      .map((word, index) => {
        if (index === 0) return word.charAt(0).toUpperCase() + word.slice(1)
        return frenchStopWords.includes(word) ? word : word
      })
      .join(' ')
  }
  return title(text)
}
